export default `
# Program
`



// WEBPACK FOOTER //
// ./src/content/devdata/program/text.js